import { render, staticRenderFns } from "./OriginalTextMark.vue?vue&type=template&id=7415a625&scoped=true&"
import script from "./OriginalTextMark.vue?vue&type=script&lang=ts&"
export * from "./OriginalTextMark.vue?vue&type=script&lang=ts&"
import style0 from "./OriginalTextMark.vue?vue&type=style&index=0&id=7415a625&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7415a625",
  null
  
)

export default component.exports